export default "__VITE_ASSET__D2AA8d0N__"